import {
  createMetadataKey,
  type LogicFn,
  metadata,
  type PathKind,
  type SchemaPath,
  type SchemaPathRules,
} from "@angular/forms/signals";

export const NO_VALIDATION_CLASSES_KEY = createMetadataKey<boolean>();

export function noValidationClasses<TValue, TPathKind extends PathKind = PathKind.Root>(
  path: Readonly<SchemaPath<TValue, SchemaPathRules.Supported, TPathKind>>,
  config?: {
    readonly when?: NoInfer<LogicFn<TValue, boolean, TPathKind>>;
  }): void {
  // Note that this is not recursive, but would be nice if it was.
  // See also: https://github.com/angular/angular/issues/71266
  metadata(path, NO_VALIDATION_CLASSES_KEY, (ctx) => config?.when?.(ctx) !== false);
}
